// Google Analytics 4 helper – tracks page views on SPA navigation
// and dispatches custom `cta_click` events for any element carrying `data-track`.
const GA_ID = "G-9RETKKXPY1";

export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};

export const trackPageview = (path) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("config", GA_ID, { page_path: path });
};

let bound = false;
export const bindTrackClicks = () => {
  if (bound || typeof document === "undefined") return;
  bound = true;
  document.addEventListener("click", (e) => {
    const el = e.target?.closest?.("[data-track]");
    if (!el) return;
    const label = el.getAttribute("data-track") || "unknown";
    trackEvent("cta_click", {
      cta_label: label,
      cta_text: (el.textContent || "").trim().slice(0, 80),
      page_path: window.location.pathname + window.location.hash,
    });
  }, { passive: true });
};
